const checkboxGroupStyle = {
    root: {
        fontSize: 12,
        paddingBottom: 8,
    },
};

export default checkboxGroupStyle;
